

























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { AnalyticsInfo, MobileGetter, User, ExperimentGetter } from 'frontend/types';
import HeaderLinks from 'frontend/components/header/HeaderLinks.vue';
import SearchWidget from 'frontend/components/search/SearchWidget.vue';

export const HEADER_VISIBLE_CLASS = 'app-header-visible';

@Component({
  components: {
    HeaderLinks,
    SearchWidget,
    DjangoMessages: () =>
      // tslint:disable-next-line:space-in-parens
      import(
        /* webpackChunkName: 'DjangoMessages' */ 'frontend/components/header/DjangoMessages.vue'
      ),
  },
  computed: {
    ...mapGetters('pageHeader', ['clientType', 'isMobile', 'messages']),
    ...mapGetters('globals', ['algoliaProxyUrl', 'inExperiment']),
    ...mapState('globals', ['analytics', 'user']),
  },
})
export default class AppHeader extends Vue {
  private user!: User;
  private analytics!: AnalyticsInfo;
  private isMobile!: MobileGetter;
  private inExperiment!: ExperimentGetter;

  private mounted(): void {
    // TODO: Remove this code once :has is available on Firefox, check this commit for more details
    // https://caniuse.com/css-has
    document.body.classList.add(HEADER_VISIBLE_CLASS);
  }

  private destroyed(): void {
    document.body.classList.remove(HEADER_VISIBLE_CLASS);
  }

  private get testId(): string {
    return 'app_header';
  }

  private get identity(): string {
    return this.analytics.analytics_identity;
  }

  private get mobile(): boolean {
    return this.isMobile(this.$mq);
  }

  private get refreshedNavbarExperiment(): boolean {
    return !this.isMobile(this.$mq);
  }
}
